import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { valHooks } from 'jquery';

@Component({
	selector: 'app-system-types-view',
	templateUrl: './system-types-view.component.html',
	styleUrls: ['./system-types-view.component.scss'],
	providers: [DatePipe]
})

export class SystemTypesViewComponent implements OnInit {

	@ViewChild('addCustomer') addcustomeref: ElementRef;
	@ViewChild('editExclusions') ruleRef: ElementRef;
	@ViewChild('addVendor') addvendorref: ElementRef;
	@ViewChild('addSalesTypeEle') addsalestyperef: ElementRef;
	@ViewChild('addPaymentTermEle') addPaymentTermref: ElementRef;
	@ViewChild('addClubEle') addclubref: ElementRef;
	@ViewChild('addContactTypeEle') addcontacttyperef: ElementRef;
	@ViewChild('paymentTermsHelp') paymentTermsHelpRef: ElementRef;

	isSaving: any = false;
	isLoading = false;
	salestypes: any = [];
	supptypes: any = [];
	customertypes: any = [];
	payment_terms: any = [];
	all_types: any = [];
	color: any = 'blue'
	customerTypeForm: UntypedFormGroup;
	paymentTermsForm: UntypedFormGroup;
	vendorTypeForm: UntypedFormGroup;
	salesTypeForm: UntypedFormGroup;
	exclusionForm: UntypedFormGroup;

	contacttypes: any = [];
	contactTypeForm: UntypedFormGroup;


	clubForm: UntypedFormGroup;
	uploaddata: any = false;
	files: any = [];
	tablename: any = false;
	mapcols: any = [
		{ field: 'mfgpart', label: 'Part Number' },
		{ field: 'brand', label: 'Brand' },
		{ field: 'price', label: 'Price' },
		{ field: 'stockid', label: 'System Item Number' },
	];
	editrule_type: any = 'P';
	editrule_name: any = '';
	currentrule: any = [];
	currenttype: any = '';
	ruleset: any = [];
	ruletypes: any = {
		'B': 'Brand',
		'P': 'Product Line',
		'C': 'Item Category',
		'S': 'Specific Item'
	};
	custtypes: any = [];
	prodlines: any = [];
	categories: any = [];
	brands: any = [];
	clubs: any = [];
	mapping: any = [];
	trandate: any = '';
	duedate: any = '';
	exampleTranDate = new UntypedFormControl(new Date());
	calculatingDue: any = false;

	protectedRoles = ['INVOICE', 'STATEMENT', 'MARKETING'];
	isProtectedContact = false;
	isEditingPaymentTerm = false;

	paymentTermsSearchFilter = '';


	constructor(private ordersService: OrdersService, private inventoryService: InventoryService, private customerService: CustomerService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private route: ActivatedRoute, private location: Location, public router: Router, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private datePipe: DatePipe) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {

		this.globalSearchService.all_system_types.subscribe((alltypes: any) => {

			this.customerTypeForm = this.fb.group({
				typeid: [''],
				typename: ['', Validators.required],
				address_type: ['2', Validators.required] // Default to '2' (Visible POS)
			});

			this.vendorTypeForm = this.fb.group({
				typeid: [''],
				typename: ['', Validators.required],
			});

			this.salesTypeForm = this.fb.group({
				typeabbrev: ['', Validators.required],
				sales_type: ['', Validators.required],
				costMultiplier: ['1', Validators.required],
				loyaltypoints: ['0', Validators.required],
				fallback: [''],
				tablename: [''],
				newpricebook: [false],
				ispricebook: ['0']
			});

			this.contactTypeForm = this.fb.group({
				contact_type: ['', Validators.required],
				contact_role: ['', Validators.required],
			});


			if (alltypes) {
				this.supptypes = alltypes.supptypes;
				this.customertypes = alltypes.debtortypes;
				this.salestypes = alltypes.salestypes;
				this.contacttypes = alltypes.contacttypes;

			}
			this.inventoryService.getItemCategories().subscribe((res) => {
				Object(res).sort((a, b) => (a.categorydescription > b.categorydescription) ? 1 : ((b.categorydescription > a.categorydescription) ? -1 : 0))
				this.categories = res;
			});
			this.inventoryService.getItemProductlines().subscribe(p => {
				this.prodlines = p
			});
			this.inventoryService.getBrands().subscribe((results: any) => {
				this.brands = results;
				this.customerService.getClubs().subscribe(details => {
					this.clubs = details;
				});
			})

		});

		this.globalSearchService.terms.subscribe((terms: any) => {
			this.payment_terms = terms


			this.paymentTermsForm = this.fb.group({
				template: ['custom'],
				termsindicator: ['', Validators.required],
				terms: ['', Validators.required],
				statementperiods: ['0', Validators.required],
				daysbeforedue: ['0', Validators.required],
				dayinfollowingmonth: ['1', Validators.required],
				terms_discount: ['0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
				numpayments: ['1', [Validators.required, Validators.min(1)]],
				cc_process: ['0', Validators.required],
				decline: ['0', Validators.required],
				collect_payment: ['0', Validators.required],
				donot_print: ['0', Validators.required],
				onaccountallowed: ['0', Validators.required],
				order_entry: ['1', Validators.required],
				agefrom: ['1'],
				ageto: [null],

			});
			this.startDueDateListeners();
			this.exampleTranDate.setValue(new Date());

		});
	}

	startDueDateListeners() {
		this.paymentTermsForm.get('daysbeforedue').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('dayinfollowingmonth').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('statementperiods').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('agefrom').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('ageto').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.exampleTranDate.valueChanges.subscribe((newV) => {
			if (newV) {
				this.getExampleDueDate();
			}
		})
	}

	onDueDateTypeChange() {
		const type = this.paymentTermsForm.get('dueDateType').value;

		if (type === 'days') {
			// Set days, clear day of month
			this.paymentTermsForm.patchValue({
				dayinfollowingmonth: '0',
				statementperiods: '0'
			}, { emitEvent: false });
		} else if (type === 'dayOfMonth') {
			// Set day of month, clear days
			this.paymentTermsForm.patchValue({
				daysbeforedue: '0',
				statementperiods: '0'
			}, { emitEvent: false });
			// Set default day if not set
			if (!this.paymentTermsForm.get('dayinfollowingmonth').value ||
				this.paymentTermsForm.get('dayinfollowingmonth').value === '0') {
				this.paymentTermsForm.patchValue({
					dayinfollowingmonth: '10'
				}, { emitEvent: false });
			}
		} else if (type === 'endOfMonth') {
			// Set to end of month (31)
			this.paymentTermsForm.patchValue({
				daysbeforedue: '0',
				dayinfollowingmonth: '31',
				statementperiods: '0'
			}, { emitEvent: false });
		}

		// Trigger due date calculation if preview is open
		if (this.exampleTranDate.value) {
			this.getExampleDueDate();
		}
	}


	getExampleDueDate() {
		const trandateValue = this.exampleTranDate.value;
		let formattedDate: string;

		if (trandateValue instanceof Date) {
			const year = trandateValue.getFullYear();
			const month = String(trandateValue.getMonth() + 1).padStart(2, '0');
			const day = String(trandateValue.getDate()).padStart(2, '0');
			formattedDate = `${year}-${month}-${day}`;
		} else if (trandateValue) {
			formattedDate = trandateValue;
		} else {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0');
			const day = String(today.getDate()).padStart(2, '0');
			formattedDate = `${year}-${month}-${day}`;
		}

		const agefromValue = this.paymentTermsForm.get('agefrom').value;
		const agetoValue = this.paymentTermsForm.get('ageto').value;

		const data = {
			'daysbeforedue': parseInt(this.paymentTermsForm.get('daysbeforedue').value) || 0,
			'dayinfollowingmonth': parseInt(this.paymentTermsForm.get('dayinfollowingmonth').value) || 0,
			'trandate': formattedDate,
			'statementperiods': parseInt(this.paymentTermsForm.get('statementperiods').value) || 0,
			'agefrom': agefromValue && agefromValue !== null && agefromValue !== '' ? parseInt(agefromValue) : 1,
			'ageto': agetoValue && agetoValue !== null && agetoValue !== '' ? parseInt(agetoValue) : 25
		}

		this.calculatingDue = true;
		this.ordersService.exampleDueDate(data).subscribe((res) => {
			if (res.duedate) {
				let dueDateObj: Date;
				if (typeof res.duedate === 'string') {
					if (res.duedate.includes('/')) {
						const parts = res.duedate.split('/');
						dueDateObj = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
					} else if (res.duedate.includes('-')) {
						dueDateObj = new Date(res.duedate);
					} else {
						dueDateObj = new Date(res.duedate);
					}
				} else {
					dueDateObj = new Date(res.duedate);
				}
				if (!isNaN(dueDateObj.getTime())) {
					this.duedate = this.datePipe.transform(dueDateObj, 'MM/dd/yyyy') || res.duedate;
				} else {
					this.duedate = res.duedate;
				}
			} else {
				this.duedate = res.duedate;
			}

			if (res.trandate) {
				let tranDateObj: Date;
				if (typeof res.trandate === 'string') {
					if (res.trandate.includes('/')) {
						const parts = res.trandate.split('/');
						tranDateObj = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
					} else if (res.trandate.includes('-')) {
						tranDateObj = new Date(res.trandate);
					} else {
						tranDateObj = new Date(res.trandate);
					}
				} else {
					tranDateObj = new Date(res.trandate);
				}
				if (!isNaN(tranDateObj.getTime())) {
					this.trandate = this.datePipe.transform(tranDateObj, 'MM/dd/yyyy') || res.trandate;
				} else {
					this.trandate = res.trandate;
				}
			} else {
				this.trandate = res.trandate;
			}

			this.calculatingDue = false;

		}, (error) => {
			this.calculatingDue = false;
			console.error('Error calculating due date:', error);
		})
	}


	yesNoValue(input: any) {
		return (input == '1') ? 'Y' : 'N';
	}





	getFilteredPaymentTerms() {
		let filtered = this.payment_terms || [];

		if (this.paymentTermsSearchFilter) {
			const searchLower = this.paymentTermsSearchFilter.toLowerCase();
			filtered = filtered.filter(term =>
				(term.termsindicator && term.termsindicator.toLowerCase().includes(searchLower)) ||
				(term.terms && term.terms.toLowerCase().includes(searchLower))
			);
		}

		// Type filter removed - no longer using template system

		return filtered;
	}

	getPaymentTermDescription(term: any): string {
		if (!term) {return '';}

		const daysbeforedue = parseInt(term.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(term.dayinfollowingmonth) || 0;
		const statementperiods = parseInt(term.statementperiods) || 0;
		const terms_discount = parseFloat(term.terms_discount) || 0;

		const parts: string[] = [];

		if (daysbeforedue > 0 && dayinfollowingmonth === 0) {
			parts.push(`Net ${daysbeforedue}`);
		} else if (dayinfollowingmonth > 0) {
			if (dayinfollowingmonth === 31) {
				parts.push('End of month');
			} else {
				parts.push(`Day ${dayinfollowingmonth} of month`);
			}
		}

		if (statementperiods > 0) {
			parts.push(`${statementperiods} statement period(s)`);
		}

		if (terms_discount > 0) {
			parts.push(`${terms_discount}% discount`);
		}

		if (parts.length === 0) {
			return 'Custom configuration';
		}

		return parts.join(', ');
	}

	isProcessing: any = false;
	onSelect(event: any): void {
		// Show the spinner
		this.isProcessing = true;
		this.files.push(...event.addedFiles);

		const uploadPromises = this.files.map(file =>
			this.readFile(file).then(fileContents => ({
				content: fileContents,
				name: file.name,
				mime: file.type,
			}))
		);

		Promise.all(uploadPromises)
			.then(uploads => {
				const uploadRequests = uploads.map(upload =>
					this.inventoryService.uploadPriceBook(upload).toPromise()
				);

				return Promise.all(uploadRequests);
			})
			.then(resultsArray => {
				// Check if any upload contains an error
				const errorResult = resultsArray.find(result => result.error);
				if (errorResult) {
					this.globalSearchService.showNotification(errorResult.error, 'danger', 'bottom', 'right');
					this.files = []; // Clear files after successful upload
					return;
				}

				if (resultsArray.length > 0) {
					const results = resultsArray[0]; // Assuming one file is processed at a time
					if (results.tablename) {
						this.salesTypeForm.get('tablename').setValue(results.tablename);
						this.tablename = results.tablename;
						this.uploaddata = results;
						this.files = []; // Clear files after successful upload
					}
				} else {
					console.error('No results returned from upload.');
				}
			})
			.catch(error => {
				console.error('Error during file upload:', error);
				this.globalSearchService.showNotification('An error occurred while uploading the file. Please try again.', 'danger', 'bottom', 'right');
			})
			.finally(() => {
				// Hide the spinner
				this.isProcessing = false;
			});

	}

	onUploadSuccess(event: any): void {
		this.uploaddata = event; // Assign the processed data
		this.isProcessing = false; // Stop the spinner
	}

	onRemove(file: any): void {
		this.files = this.files.filter(f => f !== file); // Remove the file from the list
		if (this.files.length === 0) {
			this.uploaddata = null; // Clear data preview if no files are left
		}
	}



	updatePriceBook() {

	}

	private async readFile(file: File): Promise < string | ArrayBuffer > {
		return new Promise < string | ArrayBuffer > ((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});

		this.files = [];
	}


	editPaymentTermDispaly(atype: any) {
		this.isEditingPaymentTerm = true;
		this.isLoading = true;

		// Detect due date type from existing values
		let dueDateType = 'days';
		const daysbeforedue = parseInt(atype.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(atype.dayinfollowingmonth) || 0;
		if (dayinfollowingmonth > 0 && dayinfollowingmonth < 31) {
			dueDateType = 'dayOfMonth';
		} else if (dayinfollowingmonth === 31 || (daysbeforedue === 0 && dayinfollowingmonth > 0)) {
			dueDateType = 'endOfMonth';
		} else if (daysbeforedue > 0) {
			dueDateType = 'days';
		}

		this.paymentTermsForm = this.fb.group({
			dueDateType: [dueDateType],
			termsindicator: [atype.termsindicator, Validators.required],
			terms: [atype.terms, Validators.required],
			daysbeforedue: [atype.daysbeforedue, Validators.required],
			dayinfollowingmonth: [atype.dayinfollowingmonth, Validators.required],
			statementperiods: [atype.statementperiods || atype.statementperios || '0', Validators.required],
			terms_discount: [atype.terms_discount || '0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			numpayments: [atype.numpayments || '1', [Validators.required, Validators.min(1)]],
			cc_process: [atype.cc_process, Validators.required],
			decline: [atype.decline, Validators.required],
			collect_payment: [atype.collect_payment, Validators.required],
			donot_print: [atype.donot_print, Validators.required],
			onaccountallowed: [atype.onaccountallowed, Validators.required],
			order_entry: [atype.order_entry, Validators.required],
			agefrom: [atype.agefrom || '1'],
			ageto: [atype.ageto || null],
		});

		this.exampleTranDate.setValue(new Date());
		this.startDueDateListeners();
		this.getExampleDueDate();

		this.modalService.open(this.addPaymentTermref, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {
			this.isEditingPaymentTerm = false;
		}, (reason) => {
			this.isEditingPaymentTerm = false;
		});

		this.isLoading = false;
	}

	editCustomerTypeDisplay(atype: any) {
		this.isLoading = true;

		this.customerTypeForm = this.fb.group({
			typeid: [atype.typeid],
			typename: [atype.typename, Validators.required],
			address_type: [atype.address_type, Validators.required],
		});


		this.modalService.open(this.addcustomeref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {

		});

		this.isLoading = false;

	}

	editCustomerType(type: any) {
		this.isLoading = true
		if (this.customerTypeForm.valid) {
			this.globalsService.saveCustomerType(this.customerTypeForm.value).subscribe(result => {
				this.customertypes = result;
				this.modalService.dismissAll();
			});
		}

		this.isLoading = false
	}

	removeCustomerType(type: any) {
		this.isLoading = true

		this.globalsService.removeCustomerType(type).subscribe(result => {
			this.customertypes = result;
		});

		this.isLoading = false
	}

	addCustomerType() {
		this.isLoading = true

		if (this.customerTypeForm.valid) {
			this.globalsService.saveCustomerType(this.customerTypeForm.value).subscribe(result => {
				this.customertypes = result;
				this.modalService.dismissAll();
			});
		}

		this.isLoading = false
	}
	typechange() {

		this.editrule_type = this.exclusionForm.get('rule_type').value;
	}
	editCustomerTypeExclusions(custtype: any) {

		this.editrule_type = 'P';
		const data = { 'typeid': custtype.typeid };
		this.editrule_name = custtype.typename;
		this.currenttype = custtype.typeid;
		this.currentrule = '';
		this.globalsService.getTypeExclusionRules(data).subscribe((a) => {
			this.ruleset = a;

			this.exclusionForm = this.fb.group({
				'rule_type': ['', Validators.required],
				'rule_inclusive': ['1'],
				'rule_value': ['', Validators.required],
			});
			this.modalService.open(this.ruleRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}
	editRule(rule: any) {

		this.editrule_type = rule.ruletype;
		this.currentrule = rule.id;
		this.exclusionForm = this.fb.group({
			rule_type: [rule.ruletype, Validators.required],
			rule_value: [rule.rulevalue, Validators.required],
			rule_inclusive: [rule.inclusive, Validators.required],
		});
	}
	deleteRule(ruleid: any) {
		const data = {
			'typeid': this.currenttype,
			'id': ruleid.id,
		};

		this.globalsService.deleteExclusionRule(data).subscribe(r => {
			this.ruleset = r;
		});

	}
	saveRule() {

		const data = {
			'typeid': this.currenttype,
			'id': this.currentrule,
			'rule_type': this.exclusionForm.get('rule_type').value,
			'rule_value': this.exclusionForm.get('rule_value').value,
			'rule_inclusive': this.exclusionForm.get('rule_inclusive').value
		};

		this.globalsService.saveExclusionRule(data).subscribe(r => {
			this.ruleset = r;
			this.currentrule = '';
			this.exclusionForm.get('rule_value').setValue('');
			this.exclusionForm.get('rule_type').setValue('');
		});
	}
	addPaymentTermView() {
		this.isEditingPaymentTerm = false;
		this.isLoading = true;

		this.paymentTermsForm = this.fb.group({
			dueDateType: ['days'],
			termsindicator: ['', Validators.required],
			terms: ['', Validators.required],
			daysbeforedue: ['0', Validators.required],
			dayinfollowingmonth: ['0', Validators.required],
			statementperiods: ['0', Validators.required],
			terms_discount: ['0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			numpayments: ['1', [Validators.required, Validators.min(1)]],
			cc_process: ['0', Validators.required],
			decline: ['0', Validators.required],
			collect_payment: ['0', Validators.required],
			donot_print: ['0', Validators.required],
			onaccountallowed: ['0', Validators.required],
			order_entry: ['1', Validators.required],
			agefrom: ['1'],
			ageto: [null],
		});

		this.exampleTranDate.setValue(new Date());
		this.startDueDateListeners();
		this.getExampleDueDate();

		this.modalService.open(this.addPaymentTermref, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {
			this.isEditingPaymentTerm = false;
		}, (reason) => {
			this.isEditingPaymentTerm = false;
		});
		this.isLoading = false;
	}


	addCustomerTypeView() {
		this.isLoading = true

		this.modalService.open(this.addcustomeref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	addVendorTypeDisplay() {
		this.isLoading = true

		this.modalService.open(this.addvendorref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	editVendorTypeDisplay(atype: any) {
		this.isLoading = true

		this.vendorTypeForm = this.fb.group({
			typeid: [atype.typeid],
			typename: [atype.typename, Validators.required],
		});

		this.modalService.open(this.addvendorref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	removeVendorType(type: any) {
		this.isLoading = true

		this.globalsService.removeVendorType(type).subscribe(result => {
			this.supptypes = result;
		});

		this.isLoading = false
	}

	editSalesTypeDispaly(atype: any) {
		this.salesTypeForm = this.fb.group({
			typeabbrev: [atype.typeabbrev, Validators.required],
			sales_type: [atype.sales_type, Validators.required],
			costMultiplier: [atype.sales_type, Validators.required],
			loyaltypoints: [atype.loyaltypoints, Validators.required],
			ispricebook: [atype.ispricebook, Validators.required],
			fallback: [atype.fallback],
			newpricebook: [false],
			tablename: [''],
		});

		this.modalService.open(this.addsalestyperef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

	}

	addVendorType() {
		if (this.vendorTypeForm.valid) {
			this.globalsService.saveVendorType(this.vendorTypeForm.value).subscribe(result => {
				this.supptypes = result;
				this.modalService.dismissAll();
			});
		}
	}

	editSalesType(type: any) {

	}

	removeSalesType(type: any) {
		//TODO! PREVENT THIS IF CUSTOMERS SETUP @ PRICE TYPE
		const confirm_remove = confirm('Remove sales type ' + type.typeabbrev + '?');
		if (confirm_remove) {
			this.globalsService.removeSalesType(type).subscribe(result => {
				this.salestypes = result;
			});
		}
	}

	removePaymentTerm(type: any) {
		//TODO! PREVENT THIS
		const confirm_remove = confirm('Remove Term ' + type.typename + '?');
		if (confirm_remove) {
			this.globalsService.removePaymentTerm(type).subscribe(result => {
				this.payment_terms = result;
			});
		}

	}

	addPaymentTerm() {
		if (this.paymentTermsForm.valid) {
			const formValue = { ...this.paymentTermsForm.value };
			delete formValue.dueDateType; // Remove UI-only field

			if (!this.validatePaymentTermFields(formValue)) {
				return;
			}

			if (formValue.termsindicator && formValue.termsindicator.length > 4) {
				this.globalSearchService.showNotification('Payment term code must be 4 characters or less', 'danger', 'bottom', 'right');
				return;
			}

			if (!this.isEditingPaymentTerm) {
				const existingTerm = this.payment_terms.find(t => t.termsindicator === formValue.termsindicator);
				if (existingTerm) {
					this.globalSearchService.showNotification('Payment term code already exists. Please use edit instead.', 'danger', 'bottom', 'right');
					return;
				}
			}

			if (this.isEditingPaymentTerm) {
				formValue._is_update = true;
			}

			this.globalsService.savePaymentTerm(formValue).subscribe(result => {
				if (result && result.error) {
					this.globalSearchService.showNotification(result.error, 'danger', 'bottom', 'right');
				} else {
					this.payment_terms = result;
					this.globalsService.getTerms().subscribe(terms => {
						this.globalSearchService.terms.next(terms);
					});
					this.modalService.dismissAll();
					this.isEditingPaymentTerm = false;
					this.globalSearchService.showNotification('Payment term saved successfully', 'success', 'bottom', 'right');
				}
			}, error => {
				this.globalSearchService.showNotification('Error saving payment term', 'danger', 'bottom', 'right');
			});
		}
	}

	validatePaymentTermFields(formValue: any): boolean {
		const dueDateType = formValue.dueDateType;
		const daysbeforedue = parseInt(formValue.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(formValue.dayinfollowingmonth) || 0;

		if (!dueDateType) {
			this.globalSearchService.showNotification('Please select when payment is due', 'danger', 'bottom', 'right');
			return false;
		}

		if (dueDateType === 'days' && daysbeforedue === 0) {
			this.globalSearchService.showNotification('Please enter number of days', 'danger', 'bottom', 'right');
			return false;
		}

		if (dueDateType === 'dayOfMonth' && (dayinfollowingmonth === 0 || dayinfollowingmonth > 31)) {
			this.globalSearchService.showNotification('Please enter a valid day of month (1-31)', 'danger', 'bottom', 'right');
			return false;
		}

		return true;
	}

	addSalesTypeDisplay() {
		this.salesTypeForm.reset();
		this.modalService.open(this.addsalestyperef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	addSalesType() {

		if (this.salesTypeForm.valid) {
			this.isSaving = true;
			this.globalsService.saveSalesType(this.salesTypeForm.value).subscribe(result => {
				this.isSaving = false;
				this.salestypes = result.salestypes;
				this.uploaddata = [];
				this.modalService.dismissAll();
			});
		}

	}
	addClubDisplay() {

		this.clubForm = this.fb.group({
			id: [],
			club: ['', Validators.required],
		});
		this.modalService.open(this.addclubref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	editClubDisplay(club: any) {

		this.clubForm = this.fb.group({
			id: [club.id],
			club: [club.club, Validators.required],
		});
		this.modalService.open(this.addclubref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	addClub() {

		this.customerService.saveClub(this.clubForm.value).subscribe(result => {
			this.clubs = result;
		});
	}
	removeClub(type: any) {
		//TODO! PREVENT THIS IF CUSTOMERS SETUP @ CLUB
		const confirm_remove = confirm('Remove club ' + type.club + '?');
		if (confirm_remove) {
			this.customerService.removeClub(type).subscribe(result => {
				this.clubs = result.clubs;
				if (result.success) {
					this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
				} else {
					this.globalSearchService.showNotification('Club still contains customers', 'danger', 'bottom', 'right');
				}
			});
		}
	}
	getFallbackLevel() {
		const value: string = this.salesTypeForm.get('typeabbrev').value;
		return (value != 'J' && value != 'B') ? 'B' : '';
	}


	back(): void {
		this.location.back()
	}

	ngAfterViewInit(): void {

	}


	editContactTypeDisplay(type: any) {
		this.isLoading = true;

		this.isProtectedContact = this.protectedRoles.includes(type.contact_role?.toUpperCase());

		this.contactTypeForm = this.fb.group({
			contact_type: [type.contact_type, Validators.required],
			contact_role: [{ value: type.contact_role, disabled: this.isProtectedContact }, Validators.required],
		});

		this.modalService.open(this.addcontacttyperef, {
			ariaLabelledBy: 'modal-title',
			size: 'xl'
		}).result.finally(() => {
			this.isProtectedContact = false;
		});

		this.isLoading = false;
	}


	addOrUpdateContactType() {
		if (this.contactTypeForm.valid) {
			this.globalsService.saveContactType(this.contactTypeForm.value).subscribe(result => {
				this.contacttypes = result;
				this.modalService.dismissAll();
			});
		}
	}

	removeContactType(type: any) {
		const isProtected = this.protectedRoles.includes(type.contact_role?.toUpperCase());

		if (isProtected) {
			alert('This contact role is system-defined and cannot be removed.');
			return;
		}

		const confirm_remove = confirm('Remove contact type ' + type.contact_type + '?');
		if (confirm_remove) {
			this.globalsService.removeContactType(type).subscribe(result => {
				this.contacttypes = result;
			});
		}
	}


	addContactTypeDisplay() {
		this.contactTypeForm.reset(); // clear any previous data
		this.modalService.open(this.addcontacttyperef, {
			ariaLabelledBy: 'modal-title',
			size: 'xl'
		}).result.finally(() => {
			this.isProtectedContact = false;
		});
	}

	openPaymentTermsHelp() {
		this.modalService.open(this.paymentTermsHelpRef, {
			ariaLabelledBy: 'modal-title',
			size: 'lg'
		});
	}




}